import { createSlice, createAction } from '@reduxjs/toolkit'
import moment from 'moment-timezone'

import { dateRangeConst } from 'constants/dateRangeConstants'

const initialState = {
  groupId: null,
  selectedDateRange: {
    id: dateRangeConst.currentMonth.id,
    label: dateRangeConst.currentMonth.label,
    value: {
      start_timestmp: moment().startOf('month').utc().unix(),
      end_timestmp: moment().endOf('month').utc().unix(),
    },
  },
  lastUpdateTime: null,
  isFetchingGroupData: false,
  groupData: {
    avg_energy_intensity: null,
    total_cost: null,
    total_consumption: null,
    locations: [],
  },
}
export const getIsFetchingSelector = (state) =>
  state.overview.isFetchingGroupData

export const getGroupDataLocationsSelector = (state) => {
  return state.overview.groupData?.locations?.reduce(
    (res, item, index) => {
      res.categories.push(`Facility №${index + 1}`)
      res.seriesConsaption.push(item['consumption'])
      res.seriesIntencity.push(item['intensity'])
      res.items.push(item)

      return res
    },
    {
      categories: [],
      seriesConsaption: [],
      seriesIntencity: [],
      items: [],
    }
  )
}

export const getLastUpdateDateSelector = (state) =>
  state.overview.lastUpdateTime

export const getGroupDataTotalSelector = (state) => ({
  avg_energy_intensity: state.overview.groupData.avg_energy_intensity,
  total_cost: state.overview.groupData.total_cost,
  total_consumption: state.overview.groupData.total_consumption,
})

export const getSelectedDateRangeSelector = (state) => {
  return state.overview.selectedDateRange
}

export const getGroupIdSelector = (state) => state.overview.groupId

export const getOverviewMapCoordSelector = (groupId) => (state) => {
  const locations = state?.profile?.userData?.locations || []

  return locations.reduce((res, location) => {
    if (location?.group?.id === groupId) {
      res.push({
        lat: location.latitude,
        lng: location.longitude,
        id: location.id,
        name: location.name,
      })
    }

    return res
  }, [])
}

const overviewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    setDateRange(state, action) {
      state.selectedDateRange = action.payload
    },
    setGroupId(state, action) {
      state.groupId = action.payload
    },
    clearGroupData(state) {
      state.groupData = initialState.groupData
    },
    setGroupData(state, action) {
      state.groupData = action.payload
    },
    setIsFetchingGroupData(state, action) {
      state.isFetchingGroupData = action.payload
    },
    setLastUpdateGroupData(state, action) {
      state.lastUpdateTime = action.payload
    },
    setDefaultDateSelect(state, action) {
      state.selectedDateRange = action.payload
    },
  },
})

export const getGroupOverviewData = createAction(
  'overview/getGroupOverviewData'
)

export const {
  setDateRange,
  setGroupId,
  setGroupData,
  setIsFetchingGroupData,
  setLastUpdateGroupData,
  setDefaultDateSelect,
  clearGroupData,
} = overviewSlice.actions

export default overviewSlice.reducer
